iScreenWizard.factory('Matchingrapporttype', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('matchingrapporttype').then(function (response) {
                var matchingrapporttypes = response.data;
                resolve(matchingrapporttypes);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('matchingrapporttype/'+id).then(function (response) {
                var matchingrapporttype = response.data;
                resolve(matchingrapporttype);
            }, reject);
        });
    };

    return data;
});